/* ============================================================
   TOKYOTRENDS CUSTOM JS - ULTIMATE (WISHLIST + SEARCH FIX + LIST/GRID + LIMIT)
   1. Specifications 深度检测
   2. Desktop Menu Hover
   3. Global Card Click
   4. Home Grid Arrow Injector
   5. Collection Grid Switcher (List/Grid 视图切换版)
   6. Cart Shipping Bar
   7. Wishlist Icon Re-position (挪到 Search 之前)
   ============================================================ */

let isUpdatingShippingBar = false;

// --- [7. Wishlist 挪位置核心逻辑] ---
function moveWishlistIcon() {
  const wishlistIcon = document.querySelector('.Joy-Wishlist-HeaderIcon') || 
                       document.querySelector('[class*="Joy-Wishlist-WishlistButtonWrapper"]');
  const searchIcon = document.querySelector('.header__search');

  if (wishlistIcon && searchIcon && wishlistIcon.nextSibling !== searchIcon) {
    searchIcon.parentNode.insertBefore(wishlistIcon, searchIcon);
    wishlistIcon.style.display = 'flex'; 
    console.log('TokyoTrends: Wishlist icon moved before Search');
  }
}

// --- [1 & 2. 基础逻辑] ---
function initTokyoTrends() {
  const accordions = document.querySelectorAll('.product__accordion');
  accordions.forEach(accordion => {
    const title = accordion.querySelector('.accordion__title')?.innerText.trim().toLowerCase() || '';
    if (title.includes('specifications')) {
      const contentDiv = accordion.querySelector('.accordion__content');
      const actualText = contentDiv ? contentDiv.textContent.replace(/[\s\u00A0]/g, '') : '';
      if (actualText.length === 0) {
        accordion.classList.add('is-empty');
        const summary = accordion.querySelector('summary');
        if (summary) { summary.style.pointerEvents = 'none'; summary.style.cursor = 'not-allowed'; }
      }
    }
  });

  if (window.innerWidth >= 990) {
    const menuDetails = document.querySelectorAll('header-menu details');
    menuDetails.forEach((details) => {
      if (!details.getAttribute('data-hover-bound')) {
        details.addEventListener('mouseenter', () => details.setAttribute('open', ''));
        details.addEventListener('mouseleave', () => details.removeAttribute('open'));
        details.setAttribute('data-hover-bound', 'true');
      }
    });
  }
}

// --- [3. Global Card Click] ---
function initCardClick() {
  if (window.cardClickBound) return;
  document.body.addEventListener('click', function(e) {
    if (e.target.closest('.custom-grid-arrow')) return;
    const cardInner = e.target.closest('.card__inner');
    if (cardInner) {
      const cardContainer = cardInner.closest('.card') || cardInner.closest('.card-wrapper');
      const productLink = cardContainer?.querySelector('a.full-unstyled-link');
      if (productLink?.href) {
        window.location.href = productLink.href;
      }
    }
  });
  window.cardClickBound = true;
}

// --- [4. Home & Related Grid Arrows] ---
function initHomeGridArrows() {
  const allCards = document.querySelectorAll('.card-wrapper, .card'); 
  allCards.forEach(card => {
    const inner = card.querySelector('.card__inner');
    if (!inner || inner.querySelector('.custom-grid-arrow')) return;

    const imageData = inner.getAttribute('data-all-images');
    if (!imageData) return;
    const allImages = imageData.split(',').filter(img => img.trim() !== '');
    if (allImages.length <= 1) return;

    const arrowSvg = `<svg viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" style="pointer-events: none;"><path d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg>`;
    
    inner.insertAdjacentHTML('beforeend', `
      <div class="custom-grid-arrow custom-grid-arrow--prev" data-dir="prev" onclick="handleTTClick(event, this, 'prev')" style="z-index: 999999 !important;">${arrowSvg}</div>
      <div class="custom-grid-arrow custom-grid-arrow--next" data-dir="next" onclick="handleTTClick(event, this, 'next')" style="z-index: 999999 !important;">${arrowSvg}</div>
    `);

    const mainImgs = inner.querySelectorAll('img'); 
    inner.addEventListener('mouseenter', () => {
      if (!inner.getAttribute('data-current-index')) {
        mainImgs.forEach(img => updateCardImage(img, allImages[1]));
        inner.setAttribute('data-current-index', '1');
      }
    });
    inner.addEventListener('mouseleave', () => {
      mainImgs.forEach(img => updateCardImage(img, allImages[0]));
      inner.removeAttribute('data-current-index');
    });
  });
}

window.handleTTClick = function(e, btn, dir) {
  e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
  const inner = btn.closest('.card__inner');
  const imageData = inner.getAttribute('data-all-images');
  if (!imageData) return false;
  const allImages = imageData.split(',').map(img => img.trim());
  
  const mainImgs = inner.querySelectorAll('img'); 
  if (mainImgs.length === 0) return false;

  let currentIndex = parseInt(inner.getAttribute('data-current-index') || 0);
  currentIndex = dir === 'next' ? (currentIndex + 1) % allImages.length : (currentIndex - 1 + allImages.length) % allImages.length;
  inner.setAttribute('data-current-index', currentIndex);
  
  mainImgs.forEach(img => updateCardImage(img, allImages[currentIndex]));
  return false; 
};

function updateCardImage(img, url) {
  if (!url || !img) return;
  let finalUrl = url.startsWith('//') ? 'https:' + url : url;
  img.removeAttribute('srcset');
  img.src = finalUrl + (finalUrl.includes('?') ? '&' : '?') + 'width=533';
}

// --- [5. Collection Grid Switcher - List/Grid 模式切换] ---
function initGridSwitcher() {
  const switcher = document.querySelector('.custom-grid-switcher');
  const gridContainer = document.querySelector('.product-grid-container');
  if (!switcher || !gridContainer) return;

  const buttons = switcher.querySelectorAll('.grid-view-btn');
  buttons.forEach(btn => {
    if (btn.getAttribute('data-bound')) return;
    btn.onclick = (e) => {
      e.preventDefault();
      const view = btn.getAttribute('data-view');
      applyGridView(view, buttons, gridContainer);
      localStorage.setItem('tokyoTrendsViewMode', view);
    };
    btn.setAttribute('data-bound', 'true');
  });

  // 读取上次保存的模式，默认为 grid
  const savedView = localStorage.getItem('tokyoTrendsViewMode') || 'grid';
  applyGridView(savedView, buttons, gridContainer);
}

function applyGridView(view, buttons, container) {
  buttons.forEach(b => {
    if (b.getAttribute('data-view') === view) {
      b.classList.add('active');
    } else {
      b.classList.remove('active');
    }
  });
  container.setAttribute('data-view', view);
  container.removeAttribute('data-cols'); // 清除旧的列数属性
}

// --- [6. Cart Shipping Bar] ---
function initCartShippingBar() {
  if (isUpdatingShippingBar) return;
  const container = document.querySelector('.cart-shipping-threshold');
  const subtotalElement = document.querySelector('.totals__total-value');
  if (!container || !subtotalElement) return;

  const threshold = parseInt(container.dataset.threshold); 
  const barFill = container.querySelector('.shipping-bar-fill');
  const message = container.querySelector('.shipping-threshold-message');
  const currentTotal = Math.round(parseFloat(subtotalElement.innerText.replace(/[^0-9.]/g, '')) * 100);

  isUpdatingShippingBar = true;
  if (currentTotal < threshold) {
    let percentage = (currentTotal / threshold) * 100;
    barFill.style.width = percentage + '%';
    const remaining = ((threshold - currentTotal) / 100).toFixed(2);
    message.innerHTML = `You're only <span class="remaining-amount">$${remaining} AUD</span> away from <strong>Free Shipping!</strong>`;
    container.classList.remove('is-full');
  } else {
    container.classList.add('is-full');
    message.innerHTML = `🎉 You've unlocked <strong>Free Shipping!</strong>`;
    barFill.style.width = '100%';
  }
  setTimeout(() => { isUpdatingShippingBar = false; }, 100);
}

// --- 【统一启动函数】 ---
function runAll() {
  initTokyoTrends();
  initHomeGridArrows();
  initGridSwitcher();
  initCartShippingBar();
  moveWishlistIcon();
}

document.addEventListener('DOMContentLoaded', () => {
  runAll();
  initCardClick();
});

// --- 监控 DOM 变化：隔离搜索框，侦测 Wishlist ---
const globalObserver = new MutationObserver((mutations) => {
  const shouldRun = Array.from(mutations).some(m => {
    const target = m.target;
    if (target.closest?.('.predictive-search') || target.closest?.('.search-modal')) return false;
    if (target.closest?.('.custom-grid-arrow')) return false;
    return true;
  });
  if (shouldRun) runAll();
});
globalObserver.observe(document.body, { childList: true, subtree: true });